{
  "version": 1,
  "asset_id": "72039533-0826-42ba-8780-5991bc12a32c",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/72039533-0826-42ba-8780-5991bc12a32c/lecanto-metal-roof-before-480w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/72039533-0826-42ba-8780-5991bc12a32c/lecanto-metal-roof-before-480w.avif",
  "original_filename": "lecanto-metal-roof-before-480w.avif",
  "size": 26255,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:47Z"
}
